"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sdkInfo = {
    host: 'npmjs.com',
    version: '5.3.3',
    name: 'kentico-cloud-delivery'
};
//# sourceMappingURL=sdk-info.generated.js.map